export default __webpack_public_path__ + "static/media/Group 167@2x.791467aa.png";